import { CSSObject } from '@emotion/react';
import theme from './theme';
import { mobile } from './media';

const { color, radius } = theme;

const header: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
  margin: '12px 0 20px',
  '> div': {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  h3: { margin: 0 },
  [mobile]: {
    flexWrap: 'wrap',
    margin: '20px 0 16px',
  },
};

const layout: CSSObject = {
  display: 'grid',
  gridTemplateColumns: '360px minmax(0, 1fr)',
  gap: 20,
  alignItems: 'start',
  [mobile]: {
    gridTemplateColumns: 'minmax(0, 1fr)',
    gap: 12,
  },
};

const cardMobile: CSSObject = {
  padding: '20px 16px',
  borderRadius: radius.lg,
};

const card: CSSObject = {
  background: color.white,
  borderRadius: radius.xl,
  padding: 24,
  minWidth: 0,
  [mobile]: cardMobile,
};

const previewCard: CSSObject = {
  ...card,
  position: 'sticky',
  top: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 16,
  [mobile]: {
    ...cardMobile,
    position: 'static',
    order: 2,
  },
};

const cardHead: CSSObject = {
  alignSelf: 'stretch',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  h4: {
    flex: 'none',
    whiteSpace: 'nowrap',
    fontSize: 16,
    fontWeight: 700,
    color: color.text,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    small: {
      fontSize: 14,
      fontWeight: 600,
      color: color.textMuted,
    },
  },
  p: {
    minWidth: 0,
    fontSize: 12,
    color: color.textMuted,
    textAlign: 'right',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};

const phone: CSSObject = {
  position: 'relative',
  width: 312,
  maxWidth: '100%',
  height: 640,
  boxSizing: 'border-box',
  padding: '28px 0 0',
  border: `10px solid ${color.primary}`,
  borderRadius: 44,
  background: color.white,
  overflow: 'hidden',
  boxShadow: `0 0 0 1px ${color.grey100}, ${theme.shadow.popover}`,
  '::before': {
    content: '""',
    position: 'absolute',
    top: 8,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 88,
    height: 22,
    borderRadius: radius.pill,
    background: color.primary,
    zIndex: 2,
  },
  [mobile]: {
    height: 560,
  },
};

const phoneScreen: CSSObject = {
  height: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingBottom: 24,
  scrollbarWidth: 'none',
  '::-webkit-scrollbar': { display: 'none' },
  '> div + div': {
    marginTop: 40,
  },
};

const phoneEmpty: CSSObject = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  color: color.grey400,
  fontSize: 13,
};

const listCard: CSSObject = {
  ...card,
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  [mobile]: {
    ...cardMobile,
    order: 1,
  },
};

export {
  header,
  layout,
  card,
  previewCard,
  cardHead,
  phone,
  phoneScreen,
  phoneEmpty,
  listCard,
};
